import type { Project } from '../api/types';

/**
 * مقدار مسیر API پروژه: ترجیح با slug دامنه پنل؛ در غیر این صورت id.
 */
export function projectApiRef(
  project: Pick<Project, 'id' | 'slug'> | null | undefined,
  domainSlug?: string | null,
): string {
  const slug = project?.slug?.trim() || domainSlug?.trim() || '';
  if (slug) return slug;
  return project?.id ?? '';
}
